import { useGetQuery, type UseGetQueryOptions } from "@src/appV2/api";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib";

import {
  type GetDocumentZendeskTicketsResponse,
  getDocumentZendeskTicketsResponseSchema,
} from "../types/workerDocument.types";

interface UseGetDocumentZendeskTicketsParams {
  documentId: string;
}

export const GET_DOCUMENT_ZENDESK_TICKETS_URL = `${environmentConfig.REACT_APP_DOCUMENTS_SERVICE_REST_API_URL}/documents/:documentId/zendesk-tickets`;

export function useGetDocumentZendeskTickets(
  params: UseGetDocumentZendeskTicketsParams,
  options: UseGetQueryOptions<GetDocumentZendeskTicketsResponse> = {}
) {
  const { documentId } = params;

  return useGetQuery({
    url: GET_DOCUMENT_ZENDESK_TICKETS_URL.replace(":documentId", documentId),
    responseSchema: getDocumentZendeskTicketsResponseSchema,
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.GET_DOCUMENT_ZENDESK_TICKETS_FAILURE,
    },
    ...options,
  });
}
